<template>
    <div class="card">
        <div class="bg-blue-light p-1">
            <TitleButton 
                :showBtn="false"
                title="Stage"
                :showAddNew="true"
                :btnTitle="`${currentStage ? currentStage.current_stage_name : 'Update Stage'}`"
                @onClickAddNewButton="onClickAddNew"
            />
        </div>
        <div class="my-2 px-2">
            <DateQuerySetter
                btnTitle="Go"
                @onClickGo="onClickToGo"
                class="tds-vds-query-setter"
            >
            </DateQuerySetter>
        </div>

        <div class="col-12 px-2 mt-2 mb-4">
          <div class="card p-2" style="min-height: 200px">
            <table class="table">
              <thead>
              <tr>
                <th>#</th>
                <th>Date & Time</th>
                <th>Previous Stage</th>
                <th>Updated Stage</th>
                <th>Updated By</th>
                <th>Notes</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, i) in tableItems" :key="i">
                <td>{{ ++i }}</td>
                <td>{{ item.start_time }}</td>
                <td>{{ item.previous_stage_name }}</td>
                <td>{{ item.beneficiary_stage_name }}</td>
                <td>{{ item.updated_by }}</td>
                <td v-html="item.full_description"></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="px-2 position-absolute bottom-0 mt-4">
            <Pagination :offset="params.offset" @onPageChange="onPageChange" ref="pagination"/>
        </div>

        <Loader v-if="loading"/>

      <DealStageModal
          v-if="isBeneficiaryModalOpen"
          :dealId="dealId"
          @close="closeBeneficiaryStageModal"
          @submit="getStageData"
      />
    </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import { inject, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Loader from '@/components/atom/LoaderComponent'
import Pagination from '@/components/atom/Pagination'
import DateQuerySetter from '@/components/atom/DateQuerySetter.vue';
import DealStageModal from '@/components/molecule/company/admin/open-deal/DealStageModal.vue';
import handleAdmin from '@/services/modules/admin/admin';

const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const loading = ref(false)
const tableItems = ref([]);
const currentStage = ref(null);
const params = ref({
    offset: 20,
});
const isBeneficiaryModalOpen = ref(false)

const props = defineProps({
    dealId: {
        type: Number,
        required: true
    },
    dealCustomer: {
        type: Object,
        required: true
    },
    dealData: {
        type: Object,
        required: true
    },
})

const { fetchSalePipelineStage } = handleAdmin();

const onClickToGo = () => {
   getStageData();
}

const setPaginationData = (data) => {
    store.commit('setPaginationData', data)
};

const setPagination = (data) => {
    setPaginationData({
        records: data.total,
        perPage: data.per_page,
        currentPage: data.current_page,
    })
}

const onClickAddNew = () => {
  isBeneficiaryModalOpen.value = true
}

const closeBeneficiaryStageModal = () => {
  isBeneficiaryModalOpen.value = false
}

const onPageChange = async (page) => {
    let routeQuery = Object.assign({}, route.query)
    routeQuery.page = page
    await router.push({path: route.path, query: routeQuery})
    await getStageData();
}

const getStageData = async () => {
    const query = getQuery();
    loading.value = true
    tableItems.value = []

    await fetchSalePipelineStage(query).then(res => {
        if (!res.status){
            store.commit("resetPagination")
            return
        }
        currentStage.value = res.data.current_stage;
        tableItems.value = res.data.data.data;
        setPagination(res.data.data)
    }).catch(err => {
        console.log(err)
    }).finally(() => {
        loading.value = false
    })
}

const getQuery = () => {
    let query = `?company_id=${route.params.companyId}&route_name=task-calendar`;
    if (route.query.page) query += '&page=' + route.query.page;
    if (route.query.start) query += '&start_date=' + route.query.start;
    if (route.query.end) query += '&end_date=' + route.query.end;
    if(props.dealId) query += `&sale_pipeline_id=${props.dealId}`;
    query += '&offset=' + params.value.offset
    return query;
}

onMounted(() => {
    Promise.all([
        getStageData(),
    ])
})

</script>
